import React, { useState, useEffect } from 'react'
import { loadStripe } from "@stripe/stripe-js";
import { useNavigate } from "react-router-dom";
import { AiOutlineArrowLeft } from "react-icons/ai";
import CheckoutSteps from '../components/Checkout/CheckoutSteps'
import Footer from '../components/Layout/Footer'
import Header from '../components/Layout/Header'
import Payment from "../components/Payment/Payment.jsx";
import axios from "axios";
import { server } from "../server";
import { toast } from "react-toastify";
import { cacheStripeKeyResponse } from "../utils/stripePaymentUi";

const PaymentBackLink = () => {
    const navigate = useNavigate();
    return (
        <div className="w-full flex justify-center py-3">
            <div className="w-[90%] 1000px:w-[70%]">
                <button
                    type="button"
                    onClick={() => navigate("/checkout")}
                    className="inline-flex items-center gap-2 rounded-lg border border-slate-200 bg-white px-4 py-2 text-sm font-semibold text-[#38513b] shadow-sm transition hover:bg-slate-50 hover:border-[#38513b]/30"
                >
                    <AiOutlineArrowLeft size={18} aria-hidden />
                    Back to checkout
                </button>
            </div>
        </div>
    );
};

const PaymentPage = () => {
    const [stripePromise, setStripePromise] = useState(null);
    const [currency, setCurrency] = useState("GBP");
    const [loading, setLoading] = useState(true);
    const [orderPayload, setOrderPayload] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        // Navigation guard: Check if order data exists
        const orderData = localStorage.getItem("latestOrder");
        if (!orderData) {
            toast.error("Please complete checkout first");
            navigate("/checkout");
            return;
        }

        const parsedOrderData = (() => {
            try {
                return JSON.parse(orderData);
            } catch {
                return null;
            }
        })();

        if (!parsedOrderData || !parsedOrderData.cart || parsedOrderData.cart.length === 0) {
            toast.error("No order data found");
            navigate("/checkout");
            return;
        }
        setOrderPayload(parsedOrderData);

        const initializePayment = async () => {
            try {
                // Get Stripe publishable key
                const keyResponse = await axios.get(`${server}/payment/stripe/key`);
                cacheStripeKeyResponse(keyResponse.data);
                if (keyResponse.data?.publishableKey) {
                    const publishableKey = keyResponse.data.publishableKey;
                    const mode = keyResponse.data?.mode || "unknown";
                    console.log(`Using Stripe ${mode} mode with key: ${publishableKey.substring(0, 20)}...`);
                    setStripePromise(loadStripe(publishableKey));
                    const orderCurrency = parsedOrderData?.currency
                        ? parsedOrderData.currency.toUpperCase()
                        : (keyResponse.data?.currency || "GBP").toUpperCase();
                    setCurrency(orderCurrency);
                } else {
                    setStripePromise(null);
                }
            } catch (error) {
                console.warn("Stripe not configured/reachable. Wallet-only payments can still continue.");
                setStripePromise(null);
            } finally {
                setLoading(false);
            }
        };

        initializePayment();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [navigate]);

    if (loading || !orderPayload) {
        return (
            <div className='w-full min-h-screen bg-[#f6f9fc]'>
                <Header />
                <br />
                <br />
                <CheckoutSteps active={2} />
                <PaymentBackLink />
                <div className="w-full flex flex-col items-center py-8">
                    <div className="w-[90%] 1000px:w-[70%]">
                        <div className="w-full bg-white rounded-md p-8 text-center">
                            <p className="text-lg">Loading payment form...</p>
                        </div>
                    </div>
                </div>
                <br />
                <br />
                <Footer />
            </div>
        );
    }

    return (
        <div className='w-full min-h-screen bg-[#f6f9fc]'>
            <Header />
            <br />
            <br />
            <CheckoutSteps active={2} />
            <PaymentBackLink />
            <Payment
                currency={currency}
                orderDataOverride={orderPayload}
                stripePromise={stripePromise}
            />
            <br />
            <br />
            <Footer />
        </div>
    )
}

export default PaymentPage